"use strict";

exports.__esModule = true;
exports.DEFAULT_LEGACY_SDK_BASE_URL = exports.DEFAULT_SDK_META = exports.LEGACY_SDK_PATH = exports.PROTOCOL = exports.HOST = void 0;
const HOST = {
  LOCALHOST: 'localhost.paypal.com',
  PAYPAL: '.paypal.com',
  PAYPALOBJECTS: 'www.paypalobjects.com'
};
exports.HOST = HOST;
const PROTOCOL = {
  HTTP: 'http:',
  HTTPS: 'https:'
}; // eslint-disable-next-line security/detect-unsafe-regex, unicorn/no-unsafe-regex

exports.PROTOCOL = PROTOCOL;
const LEGACY_SDK_PATH = /^\/api\/checkout(\.4\.0\.\d{1,3})?(\.min)?\.js/;
exports.LEGACY_SDK_PATH = LEGACY_SDK_PATH;
const DEFAULT_SDK_META = {
  url: '',
  stageHost: '',
  apiStageHost: ''
};
exports.DEFAULT_SDK_META = DEFAULT_SDK_META;
const DEFAULT_LEGACY_SDK_BASE_URL = 'https://www.paypalobjects.com/api/';
exports.DEFAULT_LEGACY_SDK_BASE_URL = DEFAULT_LEGACY_SDK_BASE_URL;